import { Button } from "@material-ui/core";
import { buildFreeMessage, buildListCategoriesMessage, buildQAFormLiveChat, buildQAFormMessage, checkMessageOutOfSession, postMessage } from "./handler/ChatBoxHandler";
import {memo, useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { updatePreviewSettingAtom } from "@/state/atom/chatBotPreview";
import Constant from "@/common/constant/Constant";
import { v4 as uuidv4} from 'uuid';

function TheEndMessage({
    message,
    setMessages,
    listCategories,
    supportThreadIdState,
    affiliationOrganization,
    messages,
    chatbotSetting,
    isModePreview,
    isMaximizedPanel, 
    setIsEnableMsgInput,
    getMessage, 
    resolvedMessages
}) {

    const previewSetting = useRecoilValue(updatePreviewSettingAtom);
    const [freeMessage, setFreeMessage] = useState('')
    const [messageState, setMessagesState] = useState(message)

    useEffect(() =>{
        if (message.idMessage !== messageState.idMessage) {
            setMessagesState(message)
        }
    }, [message])
    useEffect(() => {
        if (!isModePreview) {
            setFreeMessage(chatbotSetting.freeMsg);
        }
    }, [chatbotSetting]);

    useEffect(() => {
        if (isModePreview) {
           if(previewSetting.freeMsg !== freeMessage){
                setFreeMessage(previewSetting.freeMsg)
           }
        }
    }, [previewSetting]);

    const onClickNextSessionHandler = () => {
        if (checkMessageOutOfSession(messages, messageState.idMessage)) return;
        let nextMessage 
        if(listCategories.length === 0){
            let settings = isModePreview ? previewSetting : chatbotSetting;     
            switch(settings?.actionWhenNotResolve) {
                case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_CHAT_WITH_AGENT:
                    let idQALivechat = `qaform_${uuidv4()}`;
                    let dataLiveChat = {
                        isDefault: true,
                        formQASystem: message.formQASystem,
                        idQA: idQALivechat
                    }
                    nextMessage = buildQAFormLiveChat(dataLiveChat, resolvedMessages);
                    break;
    
                case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_FINISH:
                    let idQA = `qaform_${uuidv4()}`;
                    let data = {
                        isDefault: true,
                        data: {
                            formQASystem: messageState.formQASystem
                        },
                        idQA: idQA
                    }
                    nextMessage = buildQAFormMessage(data, resolvedMessages);
                    break;
                case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.DISPLAY_FREE_MESSAGE:
                default:
                    nextMessage = buildFreeMessage(freeMessage, 0);
                    break;
            } 
        }else{
            nextMessage = buildListCategoriesMessage(listCategories);
        }

        postMessage(nextMessage, supportThreadIdState, affiliationOrganization,false,isModePreview);
        setMessages(pev => [...pev,nextMessage]);
        setIsEnableMsgInput(true)
    };
    const isMsgTksUsingService = () => {
        if (messageState?.content && messageState?.content[0] === getMessage('bot_end_message')) {
            return true;
        }
        return false
    }

    return (
        <div className={`${isMaximizedPanel ? 'message-text  maximized-form-text' : 'message-text'} ${isMsgTksUsingService() ? 'confirm-message' : ''}`}>
            <div className="text-question">{messageState?.content?.[0]}</div>
            <Button onClick={onClickNextSessionHandler} className={isMaximizedPanel ? 'next-session-button next-session-button-maximized' : 'next-session-button next-session-button-minimized'}>
                {getMessage('bot_restart_chat')}
            </Button>
        </div>
    );
}

export default memo(TheEndMessage);